export default __webpack_public_path__ + "static/media/shutterstock_1659535873_ciencia_para_un_mundo_mejor.d81c08a4.webp";